import {SharedRegion} from "./SharedRegion";

export class RegionModel {
  id: number;
  cod: string;
  description: string;
  checked: boolean;
  isShared: boolean;
  sharedRegionObj: SharedRegion;


  constructor(id?: number, cod?: string, description?: string,
              checked?: boolean, isShared?: boolean,
              sharedRegionObj?: SharedRegion) {
    if (cod !== undefined) {
      this.cod = cod;
    }

    if (id !== undefined) {
      this.id = id;
    }

    if (description !== undefined) {
      this.description = description;
    }

    if (checked !== undefined) {
      this.checked = checked;
    }

    if (isShared !== undefined) {
      this.isShared = isShared;
    }

    if (sharedRegionObj !== undefined) {
      this.sharedRegionObj = sharedRegionObj;
    }
  }
}
